





















































































































import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeUnmount } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { SearchCondition, StudentFileUpload } from "../../modules/teacher/StudentFileUploadList"

export interface Data {
  condition: SearchCondition
  studentFileUploads: StudentFileUpload[]
  currentPage: number
  perPage: number
  fields: any[]
  errors: string[]
  title: string
  comment: string
  files: File[]
  edit_id: number
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalFileUploadRef = ref<InstanceType<typeof BModal>>();
    const modalEditRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      studentFileUploads: new Array<StudentFileUpload>(),
      currentPage: 1,
      perPage: 100,
      fields: [
        {key: "created_at", label: "アップロード日時", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "190px"}},
        {key: "file_name", label: "ファイル名", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "user_name", label: "アップロード者", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "title", label: "表題", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "comment", label: "コメント", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "file_count", label: "枚数", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
        {key: "edit", label: "編集", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
        {key: "detail", label: "ファイル一覧", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "130px"}},
        {key: "delete", label: "削除", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
      ],
      errors: [],
      title: "",
      comment: "",
      files: [],
      edit_id: null,
    });

    const convertCreatedAt = (created_at: string) => {
      return created_at ? moment(created_at).format('Y年M月D日 H:m:s') : "-";
    };

    const allDeleteSelectChanged = (isChecked: boolean) => {
      state.studentFileUploads.forEach(x => x.is_delete_checked = isChecked);
    }

    const searchClick = () => {
      state.currentPage = 1;
      search();
    };

    const search = async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      // APIで登録済み試験情報取得
      await http.get(`/api/teacher/student_file_upload_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.studentFileUploads = response.data.student_file_uploads.map((x: any) => new StudentFileUpload(x));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`画面表示に失敗しました。\n${error.response.data.errors[0]}`);
        }else{
          alert(`画面表示に失敗しました。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    };

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /************************************************************
     * 画像Zipドロップ
     ************************************************************/

    const showEditModal = (studentFileUpload: StudentFileUpload) => {

      state.title = studentFileUpload.title;
      state.comment = studentFileUpload.comment;
      state.edit_id = studentFileUpload.id;
      state.files = [];

      modalFileUploadRef.value.show();
    } 

    /************************************************************
     * モーダルクローズ
     ************************************************************/

    const closeModal = () => {

      state.title = null;
      state.comment = null;
      state.edit_id = null;
      state.files = [];
      modalFileUploadRef.value.hide();
    } 

    /************************************************************
     * 画像Zipドロップ
     ************************************************************/

    const showUploadModal = (files: FileList) => {

      state.files = [].slice.call(files)
      modalFileUploadRef.value.show();
    }

    /************************************************************
     * アップロード実行
     ************************************************************/

    const upload = async () => {
      state.errors = [];

      if(!state.title){
        alert("表題を入力してください。");
        return;
      }

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', state.files[0]);
      fd.append('file_name', state.files[0].name);
      fd.append('title', state.title);
      fd.append('comment', state.comment);

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/student_file_upload_list/upload`, fd).then(async response => {
        alert("処理が完了しました。");
        await search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      modalFileUploadRef.value.hide();

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 更新
     ************************************************************/

    const update = async () => {

      state.errors = [];

      if(!state.title){
        alert("表題を入力してください。");
        return;
      }

      if(!window.confirm("更新します。よろしいですか？")){
        return;
      }

      const param: any = {
        title: state.title,
        comment: state.comment,
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/student_file_upload_list/update/${state.edit_id}`, param).then(response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      modalFileUploadRef.value.hide();

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 削除
     ************************************************************/

    const destroy = async () => {

      state.errors = [];

      const ids = state.studentFileUploads.filter(x => x.is_delete_checked).map(x => x.id);

      if(ids.length == 0){
        alert("削除対象を選択してください。");
        return;
      }

      if (!window.confirm('選択しているレコードを削除します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/student_file_upload_list/destroy`, {ids: ids}).then(response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      search();
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalFileUploadRef,
      modalEditRef,
      upload,
      convertCreatedAt,
      searchClick,
      clearCondition,
      update,
      destroy,
      closeModal,
      showEditModal,
      showUploadModal,
      allDeleteSelectChanged,
    };
  }
});

